import type { Video } from './types';

export const getCurriculumResourceId = (video: Video, categoryId: string): string =>
  `${video.resourceId}-${categoryId}`;
